export interface StoredTokens {
  token: string;
  refreshToken: string;
  idToken?: string;
}

const STORAGE_KEY = 'calibraone.kc.tokens';

/** Remove older loose token keys if still present from previous builds. */
function clearLegacyKeys(): void {
  for (const key of ['accessToken', 'refreshToken', 'idToken', 'user'] as const) {
    sessionStorage.removeItem(key);
  }
}

/** Persist Keycloak tokens across reload (sessionStorage survives refresh, not tab close). */
export function saveTokens(tokens: StoredTokens): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(tokens));
    clearLegacyKeys();
  } catch {
    // Storage unavailable
  }
}

export function loadTokens(): StoredTokens | undefined {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return undefined;
    const parsed = JSON.parse(raw) as Partial<StoredTokens>;
    return parsed.token && parsed.refreshToken
      ? { token: parsed.token, refreshToken: parsed.refreshToken, idToken: parsed.idToken }
      : undefined;
  } catch {
    return undefined;
  }
}

export function clearTokens(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
    clearLegacyKeys();
  } catch {
    // ignore
  }
}
